import { OrthodonticsForAdultsPage } from "~/components/orthodontics-for-adults/OrthodonticsForAdultsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/orthodontics-for-adults")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo(
      "/orthodontics-for-adults",
    ),
  component: OrthodonticsForAdultsPage,
});
